import { render, staticRenderFns } from "./CollageInfo.vue?vue&type=template&id=0b46f327&scoped=true"
import script from "./CollageInfo.vue?vue&type=script&lang=js"
export * from "./CollageInfo.vue?vue&type=script&lang=js"
import style0 from "./CollageInfo.vue?vue&type=style&index=0&id=0b46f327&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b46f327",
  null
  
)

export default component.exports